import { Link } from 'react-router-dom';
import { Buildings, UserCircle, SignOut } from '@phosphor-icons/react';
import { useGuestAuth } from '../contexts/GuestAuthContext';

/**
 * Top navigation bar — Warm Editorial. Ink ground with a serif wordmark and a
 * clay accent. Logo left, account + "List your hotel" actions right.
 */
export function SiteHeader() {
  const { isAuthenticated, account, logout } = useGuestAuth();
  return (
    <header className="bg-ink text-cream">
      <div className="flex items-center justify-between px-4 py-3.5 sm:px-10 lg:px-16 2xl:px-24">
        <Link
          to="/"
          className="font-serif text-2xl font-semibold tracking-tight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clay focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
        >
          BestAcco<span className="text-clay">.</span>
        </Link>

        <nav className="flex items-center gap-2 text-sm font-medium">
          <Link
            to="/list-your-property"
            aria-label="List your hotel"
            className="flex items-center gap-1.5 rounded-full px-3 py-2 text-cream/90 transition hover:bg-white/10 hover:text-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clay sm:px-3.5"
          >
            <Buildings className="h-4 w-4 shrink-0" />
            <span className="hidden sm:inline">List your hotel</span>
          </Link>
          {isAuthenticated ? (
            <>
              <span className="hidden items-center gap-1.5 px-2 text-sm text-cream/80 sm:flex" title={account?.email ?? ''}>
                <UserCircle className="h-4 w-4" />
                {account?.email}
              </span>
              <button
                type="button"
                onClick={() => { void logout(); }}
                className="flex items-center gap-1.5 rounded-full bg-clay px-4 py-2 font-semibold text-white transition hover:bg-clay-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
              >
                <SignOut className="h-4 w-4" />
                Sign out
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="flex items-center gap-1.5 rounded-full bg-clay px-4 py-2 font-semibold text-white transition hover:bg-clay-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
            >
              <UserCircle className="h-4 w-4" />
              Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
